import smartSolveApi from './instances/smartsolve';

export const classRoomTrainingIsRequired = async (params) => {
  try {
    const { trainingProgress, actorId, rpgId } = params;

    const response = await smartSolveApi.post('/classroomtrainingisrequired', {
      trainingProgress,
      actorId,
      rpgId,
    });

    return response.data;
  } catch (e) {
    throw new Error(`classroomTrainingIsRequired() failed: ${e}`);
  }
};

export const checkPreRequisiteStatus = async (params) => {
  try {
    const { actorId, rpgId } = params;

    const response = await smartSolveApi.post('/requirementprerequisitestatus', {
      actorId,
      rpgId,
    });

    return response.data;
  } catch (e) {
    throw new Error(`checkPreRequisiteStatus() failed: ${e}`);
  }
};
